"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addFiltersToDataRequirement = exports.getFlattenedRelatedArtifacts = exports.createIntervalFromEndpoints = exports.extractDataRequirementsMeasurementPeriod = exports.generateDataRequirement = exports.addFhirQueryPatternToDataRequirements = exports.getDataRequirements = void 0;
const patient_search_parameters_1 = require("fhir-spec-tools/build/data/patient-search-parameters");
const SearchParameters_1 = require("../compartment-definition/SearchParameters");
const Execution = __importStar(require("../execution/Execution"));
const CustomErrors_1 = require("../types/errors/CustomErrors");
const QueryFilterParser_1 = require("./elm/QueryFilterParser");
const RetrievesHelper = __importStar(require("./elm/RetrievesHelper"));
const lodash_1 = require("lodash");
const cql_execution_1 = require("cql-execution");
const ValueSetHelper_1 = require("../execution/ValueSetHelper");
const MeasureBundleHelpers = __importStar(require("./MeasureBundleHelpers"));
const FHIR_QUERY_PATTERN_URL = 'http://hl7.org/fhir/us/cqfmeasures/StructureDefinition/cqfm-fhirQueryPattern';
/**
 * Returns a FHIR library containing data requirements, given a root library
 */
async function getDataRequirements(cqls, rootLibIdentifier, elmJSONs, options = {}, effectivePeriod) {
    const rootLib = elmJSONs.find(ej => ej.library.identifier == rootLibIdentifier);
    // We need a root library to run dataRequirements properly. If we don't have one, error out.
    if (!(rootLib === null || rootLib === void 0 ? void 0 : rootLib.library)) {
        throw new CustomErrors_1.UnexpectedResource("root library doesn't contain a library object");
    }
    const parameters = extractDataRequirementsMeasurementPeriod(options, effectivePeriod);
    const withErrors = [];
    // get the retrieves for every statement in the root library
    const allRetrieves = rootLib.library.statements.def.flatMap(statement => {
        if (statement.expression && statement.name != 'Patient') {
            const retrievesOutput = RetrievesHelper.findRetrieves(rootLib, elmJSONs, statement.expression);
            withErrors.push(...retrievesOutput.withErrors);
            return retrievesOutput.results;
        }
        else {
            return [];
        }
    });
    const allRetrievesPromises = allRetrieves.map(async (retrieve) => {
        // If the retrieves have a localId for the query and a known library name, we can get more info
        // on how the query filters the sources.
        if (retrieve.queryLocalId && retrieve.queryLibraryName && parameters['Measurement Period']) {
            const library = elmJSONs.find(lib => lib.library.identifier.id === retrieve.queryLibraryName);
            if (library) {
                retrieve.queryInfo = await (0, QueryFilterParser_1.parseQueryInfo)(library, elmJSONs, retrieve.queryLocalId, retrieve.valueComparisonLocalId, parameters);
            }
        }
    });
    await Promise.all(allRetrievesPromises);
    const results = {
        resourceType: 'Library',
        type: { coding: [{ code: 'module-definition', system: 'http://terminology.hl7.org/CodeSystem/library-type' }] },
        status: 'unknown'
    };
    results.dataRequirement = (0, lodash_1.uniqBy)(allRetrieves.map(retrieve => {
        const dr = generateDataRequirement(retrieve);
        addFiltersToDataRequirement(retrieve, dr, withErrors);
        addFhirQueryPatternToDataRequirements(dr);
        return dr;
    }), JSON.stringify);
    return {
        results: results,
        debugOutput: {
            cql: cqls,
            elm: elmJSONs,
            gaps: {
                retrieves: allRetrieves
            }
        },
        withErrors
    };
}
exports.getDataRequirements = getDataRequirements;
/**
 * Creates query string for the data requirement using either the code filter code or valueSet and
 * the specified endpoint, and adds a fhirQueryPattern extension to the data requirement that
 * contains the query string.
 * @param dataRequirement  Data requirement to add FHIR Query Pattern to
 */
function addFhirQueryPatternToDataRequirements(dataRequirement) {
    var _a;
    const query = createQueryFromCodeFilter(dataRequirement.codeFilter, dataRequirement.type);
    // Configure query string from query object
    let queryString = `/${query.endpoint}?`;
    for (const [key, value] of Object.entries(query.params)) {
        queryString = queryString.concat(`${key}=${value}&`);
    }
    if (dataRequirement.dateFilter) {
        dataRequirement.dateFilter.forEach(dateFilter => {
            let path = dateFilter.path || '';
            // remove period path pieces
            // NOTE: Currently we are limited in doing period comparisons within our query pattern
            // because search parameters do not allow a use of ".end" or ".start"
            // and prefixes are not sufficient for certain comparisons https://www.hl7.org/fhir/search.html#prefix
            if (path === null || path === void 0 ? void 0 : path.endsWith('.end')) {
                path = path.slice(0, -4);
            }
            else if (path === null || path === void 0 ? void 0 : path.endsWith('.start')) {
                path = path.slice(0, -6);
            }
            // add resource type
            path = `${dataRequirement.type}.${path}`;
            // identify search parameters that should be used for the query
            const foundParams = SearchParameters_1.SearchParameters.entry.filter(searchParam => searchParam.resource.expression.includes(path));
            if (foundParams.length === 1) {
                if (dateFilter.valueDateTime) {
                    queryString = queryString.concat(`${foundParams[0].resource.code}=${dateFilter.valueDateTime}&`);
                }
                else if (dateFilter.valuePeriod) {
                    if (dateFilter.valuePeriod.start) {
                        queryString = queryString.concat(`${foundParams[0].resource.code}=ge${dateFilter.valuePeriod.start}&`);
                    }
                    if (dateFilter.valuePeriod.end) {
                        queryString = queryString.concat(`${foundParams[0].resource.code}=le${dateFilter.valuePeriod.end}&`);
                    }
                }
                else if (dateFilter.valueDuration) {
                    queryString = queryString.concat(`${foundParams[0].resource.code}=${dateFilter.valueDuration.value}&`);
                }
            }
            else if (foundParams.length > 1) {
                // assumed that multiple foundParams matches is an unexpected result
                console.warn(`Unexpected result:  (${foundParams.length}) dateFilter path search parameters found`);
            }
            else if (foundParams.length == 0) {
                // (or no matches means we ignore this constraint and add nothing to the query)
                console.warn(`Could not identify search parameters using dateFilter path '${path}'`);
            }
        });
    }
    // Create an extension for each way that exists for referencing the patient
    (_a = patient_search_parameters_1.patientSearchParameters[dataRequirement.type]) === null || _a === void 0 ? void 0 : _a.forEach((patientContext) => {
        const fhirPathExtension = {
            url: FHIR_QUERY_PATTERN_URL,
            valueString: queryString.concat(`${patientContext}=Patient/{{context.patientId}}`)
        };
        // Add query to data requirement
        if (dataRequirement.extension) {
            dataRequirement.extension.push(fhirPathExtension);
        }
        else {
            dataRequirement.extension = [fhirPathExtension];
        }
    });
}
exports.addFhirQueryPatternToDataRequirements = addFhirQueryPatternToDataRequirements;
/**
 * Parses each element of codeFilter array for either the code or valueSet key, and creates
 * query object containing each code/valueSet and corresponding value.
 * @param codeFilterArray codeFilter array from DataRequirement
 * @param type dataRequirement type
 * @returns query object consisting of an endpoint and params object containing the code/valueSet
 * and value pairs
 */
function createQueryFromCodeFilter(codeFilterArray, type) {
    const query = { endpoint: type, params: {} };
    codeFilterArray === null || codeFilterArray === void 0 ? void 0 : codeFilterArray.map(codeFilter => {
        // Prefer specific code filter over valueSet
        if (codeFilter === null || codeFilter === void 0 ? void 0 : codeFilter.code) {
            query.params[`${codeFilter.path}`] = codeFilter.code[0].code;
        }
        else if (codeFilter === null || codeFilter === void 0 ? void 0 : codeFilter.valueSet) {
            query.params[`${codeFilter.path}:in`] = codeFilter.valueSet;
        }
    });
    return query;
}
/**
 * Given a DataTypeQuery object, create a DataRequirement object that represents the data
 * that would be requested from a FHIR server for that query.
 * Currently supports
 * @param retrieve a DataTypeQuery that represents a retrieve for a FHIR Resource with certain attributes
 * @returns fhir4.DataRequirement with as much attribute data as we can add
 */
function generateDataRequirement(retrieve) {
    const dataRequirement = {
        type: retrieve.dataType
    };
    // if the retrieve has a templateId, add it to the profile attribute on the data requirement
    if (retrieve.templateId) {
        dataRequirement.profile = [retrieve.templateId];
    }
    if (retrieve.valueSet) {
        dataRequirement.codeFilter = [
            {
                path: retrieve.path,
                valueSet: retrieve.valueSet
            }
        ];
    }
    else if (retrieve.code) {
        dataRequirement.codeFilter = [
            {
                path: retrieve.path,
                code: [retrieve.code]
            }
        ];
    }
    return dataRequirement;
}
exports.generateDataRequirement = generateDataRequirement;
/**
 * Extracts the measurement period information from either the options or effective period (in that order depending on presence)
 * and populates a parameters object including the extracted info to be passed into the parseQueryInfo function
 */
function extractDataRequirementsMeasurementPeriod(options, effectivePeriod) {
    if (!hasMeasurementPeriodInfo(options, effectivePeriod)) {
        return {};
    }
    const parameters = {};
    if (options.measurementPeriodStart || options.measurementPeriodEnd) {
        parameters['Measurement Period'] = createIntervalFromEndpoints(options.measurementPeriodStart, options.measurementPeriodEnd);
    }
    else {
        parameters['Measurement Period'] = createIntervalFromEndpoints(effectivePeriod === null || effectivePeriod === void 0 ? void 0 : effectivePeriod.start, effectivePeriod === null || effectivePeriod === void 0 ? void 0 : effectivePeriod.end);
    }
    return parameters;
}
exports.extractDataRequirementsMeasurementPeriod = extractDataRequirementsMeasurementPeriod;
/**
 * Creates a cql-execution interval from start to end. If either start or end is not present,
 * creates an interval with duration exactly one year using the present endpoint
 */
function createIntervalFromEndpoints(start, end) {
    let startCql, endCql;
    if (start && end) {
        ({ startCql, endCql } = Execution.getCQLIntervalEndpoints({
            measurementPeriodStart: start,
            measurementPeriodEnd: end
        }));
    }
    else {
        if (start) {
            startCql = (0, ValueSetHelper_1.parseTimeStringAsUTC)(start);
            endCql = new Date(startCql);
            endCql.setFullYear(startCql.getFullYear() + 1);
        }
        else if (end) {
            endCql = (0, ValueSetHelper_1.parseTimeStringAsUTC)(end);
            startCql = new Date(endCql);
            startCql.setFullYear(endCql.getFullYear() - 1);
        }
        startCql = cql_execution_1.DateTime.fromJSDate(startCql, 0);
        endCql = cql_execution_1.DateTime.fromJSDate(endCql, 0);
    }
    return new cql_execution_1.Interval(startCql, endCql);
}
exports.createIntervalFromEndpoints = createIntervalFromEndpoints;
function hasMeasurementPeriodInfo(options, effectivePeriod) {
    return Boolean(options.measurementPeriodStart || options.measurementPeriodEnd || (effectivePeriod === null || effectivePeriod === void 0 ? void 0 : effectivePeriod.start) || (effectivePeriod === null || effectivePeriod === void 0 ? void 0 : effectivePeriod.end));
}
/**
 * Get a flattened list of all related artifacts in the measure bundle.
 *
 * @param measureBundle The measure bundle to fetch all RelatedArtifacts from
 * @returns List of flattened related artifacts.
 */
function getFlattenedRelatedArtifacts(measureBundle, rootLibRef) {
    var _a, _b, _c, _d;
    const relatedArtifacts = [];
    if (rootLibRef) {
        // if a rootLibIdentifier is defined we should be excluding the measure info
        const { libId: rootLibId, libVersion: rootLibVersion } = MeasureBundleHelpers.parseLibRef(rootLibRef);
        // find the root library resource
        const libraryEntry = (_a = measureBundle.entry) === null || _a === void 0 ? void 0 : _a.find(entry => {
            var _a;
            if (((_a = entry.resource) === null || _a === void 0 ? void 0 : _a.resourceType) === 'Library') {
                const library = entry.resource;
                return ((library.url === rootLibId && (!rootLibVersion || library.version === rootLibVersion)) ||
                    library.id === rootLibId);
            }
        });
        if (libraryEntry === null || libraryEntry === void 0 ? void 0 : libraryEntry.resource) {
            const library = libraryEntry.resource;
            // add the root library itself
            relatedArtifacts.push({
                type: 'depends-on',
                display: library.name ? `Library ${library.name}` : 'Library',
                resource: (_b = library.url) !== null && _b !== void 0 ? _b : `Library/${library.id}`
            });
        }
    }
    else {
        const measure = MeasureBundleHelpers.extractMeasureFromBundle(measureBundle);
        // add the measure itself
        relatedArtifacts.push({
            type: 'depends-on',
            display: measure.name ? `Measure ${measure.name}` : 'Measure',
            resource: (_c = measure.url) !== null && _c !== void 0 ? _c : `Measure/${measure.id}`
        });
        // copy over related artifacts from measure
        if (measure.relatedArtifact) {
            relatedArtifacts.push(...measure.relatedArtifact);
        }
    }
    // copy over all related artifacts from all libraries
    const libraries = (_d = measureBundle.entry) === null || _d === void 0 ? void 0 : _d.filter(entry => { var _a; return ((_a = entry.resource) === null || _a === void 0 ? void 0 : _a.resourceType) === 'Library'; });
    if (libraries) {
        libraries.forEach(libraryEntry => {
            const library = libraryEntry.resource;
            if (library.relatedArtifact) {
                relatedArtifacts.push(...library.relatedArtifact);
            }
        });
    }
    // unique the relatedArtifacts
    return (0, lodash_1.uniqBy)(relatedArtifacts, JSON.stringify);
}
exports.getFlattenedRelatedArtifacts = getFlattenedRelatedArtifacts;
/**
 *
 * @param q The query which contains the filters to add to the data requirement
 * @param dataRequirement Data requirement to add date filters to
 * @param withErrors Errors object which will eventually be returned to the user if populated
 * @returns void, but populated the dataRequirement filters
 */
function addFiltersToDataRequirement(q, dataRequirement, withErrors) {
    if (q.queryInfo) {
        const relevantSource = q.queryInfo.sources.find(source => source.resourceType === q.dataType);
        // if a source cannot be found that matches, exit the function
        if (relevantSource) {
            const detailedFilters = (0, QueryFilterParser_1.flattenFilters)(q.queryInfo.filter);
            detailedFilters.forEach(df => {
                // DuringFilter, etc. inherit from attribute filter (and have alias on them)
                if (relevantSource.alias === df.alias) {
                    if (df.type === 'equals' || df.type === 'in') {
                        const cf = (0, QueryFilterParser_1.generateDetailedCodeFilter)(df, q.dataType);
                        if (cf !== null) {
                            if (dataRequirement.codeFilter) {
                                dataRequirement.codeFilter.push(cf);
                            }
                            else {
                                dataRequirement.codeFilter = [cf];
                            }
                        }
                    }
                    else if (df.type === 'during') {
                        const dateFilter = (0, QueryFilterParser_1.generateDetailedDateFilter)(df);
                        if (dataRequirement.dateFilter) {
                            dataRequirement.dateFilter.push(dateFilter);
                        }
                        else {
                            dataRequirement.dateFilter = [dateFilter];
                        }
                    }
                    else {
                        const valueFilter = (0, QueryFilterParser_1.generateDetailedValueFilter)(df);
                        if (didEncounterDetailedValueFilterErrors(valueFilter)) {
                            withErrors.push(valueFilter);
                        }
                        else if (valueFilter) {
                            if (dataRequirement.extension) {
                                dataRequirement.extension.push(valueFilter);
                            }
                            else {
                                dataRequirement.extension = [valueFilter];
                            }
                        }
                    }
                }
            });
        }
    }
}
exports.addFiltersToDataRequirement = addFiltersToDataRequirement;
function didEncounterDetailedValueFilterErrors(tbd) {
    if (tbd.message) {
        return true;
    }
    else {
        return false;
    }
}
//# sourceMappingURL=DataRequirementHelpers.js.map